import '.b1{position:relative;}.ssr-plugin'
import '.ig{width:64px;}.ssr-plugin'
import '.ih{height:64px;}.ssr-plugin'
import '.am{flex-shrink:0;}.ssr-plugin'
import '.b6{position:absolute;}.ssr-plugin'
import '.ii{bottom:-4px;}.ssr-plugin'
import '.en{right:-4px;}.ssr-plugin'
import '.fk{border-radius:50%;}.ssr-plugin'
import '.ij{border:2px solid var(--palette-white);}.ssr-plugin'
import '.ag{overflow:hidden;}.ssr-plugin'
import '.ik{width:32px;}.ssr-plugin'
import '.il{height:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Image } from '@app/components/core/image/Image'

type ConversationAvatarProps = {
  initiativeImage?: string
  userAvatar?: string
  userName: string
}

export const ConversationAvatar = ({
  initiativeImage,
  userAvatar,
  userName,
}: ConversationAvatarProps) => {
  return (
    <div className="b1 ig ih am"
    >
      {initiativeImage ? (
        <Image
          src={initiativeImage}
          resizeWidth={128}
          alt="initiative"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
      ) : (
        <Avatar
          size="medium"
          shape="square"
          labelSource={userName}
          variant="yellow"
        />
      )}
      <div className="b6 ii en fk ij ag ik il"
      >
        <Avatar
          size="extra-small"
          shape="circle"
          image={userAvatar}
          labelSource={userName}
        />
      </div>
    </div>
  )
}
